import React from 'react';
import {
  Page,
  Layout,
  Card,
  Text,
  Badge,
  BlockStack,
  InlineStack,
  Link,
  Banner,
  Box,
  SkeletonBodyText,
} from '@shopify/polaris';
import useConnectionStatus from '../hooks/useConnectionStatus';
import BillingCard from '../components/BillingCard';

export default function Dashboard() {
  const { isConnected, accountEmail, billing, loading } = useConnectionStatus();

  return (
    <Page title="ApparelHub.AI">
      <Layout>
        {!loading && !isConnected && (
          <Layout.Section>
            <Banner
              title="Connect your ApparelHub account"
              tone="warning"
              action={{
                content: 'Connect account',
                url: '/settings',
              }}
            >
              <p>
                Link your ApparelHub.AI account to sync products, manage
                fulfillment, and track orders from within Shopify.
              </p>
            </Banner>
          </Layout.Section>
        )}

        <Layout.Section>
          <Card>
            <BlockStack gap="300">
              <InlineStack align="space-between">
                <Text as="h2" variant="headingMd">
                  Connection Status
                </Text>
                {loading ? (
                  <Badge tone="info">Checking...</Badge>
                ) : (
                  <Badge tone={isConnected ? 'success' : 'attention'}>
                    {isConnected ? 'Connected' : 'Not connected'}
                  </Badge>
                )}
              </InlineStack>
              {loading ? (
                <SkeletonBodyText lines={1} />
              ) : isConnected ? (
                <Text as="p" variant="bodyMd" tone="subdued">
                  Connected as {accountEmail}
                </Text>
              ) : null}
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section variant="oneHalf">
          <Card>
            <BlockStack gap="200">
              <Text as="h2" variant="headingMd">
                Products
              </Text>
              <Text as="p" variant="bodyMd" tone="subdued">
                Manage your product catalog and sync status.
              </Text>
              <Box>
                <Link url="/products">View products</Link>
              </Box>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <BillingCard isConnected={isConnected} billing={billing} loading={loading} />
        </Layout.Section>

        <Layout.Section variant="oneHalf">
          <Card>
            <BlockStack gap="200">
              <Text as="h2" variant="headingMd">
                ApparelHub Platform
              </Text>
              <Text as="p" variant="bodyMd" tone="subdued">
                Design products, generate AI images, and manage your full
                catalog on the ApparelHub platform.
              </Text>
              <Box>
                <Link url="https://apparelhub.ai" external>
                  Open ApparelHub.AI
                </Link>
              </Box>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
